export default "__VITE_ASSET__H6y7G$Xe__"